// dir0 the relative origin direction

import { DEV } from "solid-js"
import type { DirectionDxDy } from "./DirectionDxDy.type"
import eightDirections from "./eightDirections"
import normalizeCircularOffset from "./normalizeCircularOffset"

// offset: number: how many 45 degree directional turns
export default function getNextEightDirection(dir0: DirectionDxDy, offset: number): DirectionDxDy {
  const index0 = eightDirections.indexOf(dir0)
  const normalizedOffset = normalizeCircularOffset(offset, 8)
  const index1 = (index0 + normalizedOffset) % 8
  const value = eightDirections[index1]
  if (DEV) {
    if (!value || !Object.hasOwn(eightDirections, index1)) {
      throw new Error('getNextEightDirection: value is undefined')
    }
  }
  return value!
}